module.exports = __webpack_public_path__ + "static/media/Artboard19.092b0b6f.png";